(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/graph/assets/javascripts/graph.js') >= 0) return;  svs.modules.push('/components/sport/graph/assets/javascripts/graph.js'); 
'use strict';

var svs = svs || {};

(function(svs, _) {
  svs.sport = svs.sport || {};

  svs.sport.Graph = function(options) {
    options = options || {};
    var lowestLastYXValue,
      Kinetic = window.Kinetic,
      lowestYValue,
      highestYValue,
      origsamplePoints = [],
      startLine,
      endLine,
      gridLineslayer,
      stage,
      layer,
      noOfGridLines,
      numScorePoints = 0,
      stepSize,
      origWidth,
      origStartX,
      lastXPoint,
      dateMaxOffset = 240,
      widthDiff,
      config = {
        scale: 2,
        canvasWidth: 315,
        canvasHeight: options.mobileVersion ? 75 : 140,
        gridHeight: options.mobileVersion ? 35 : 90,
        gridStartY: options.mobileVersion ? 60 : 115,
        gridStartX: 60,
        offset: options.mobileVersion ? 30 : 0,
        gridWidth: 203,
        gridPadding: 60,
        sampleRate: 5,
        wedgeWidth: 50,
        lineColor: '#ff5500',
        markColor: '#ff5500',
        dateColor: '#7d7d80',
        currentScoreColor: '#252526',
        className: 'graph',
        autoMinMax: true,
        showEndWedge: true,
        numberOfMatches: 13,
        minMax: { min: 1, max: 13 },
        points: [],
        datePoints: [],
        container: null,
        animate: true,
        autoWidth: false,
        mobileVersion: false
      };

    var self = this;
    this.normalizedPoints = [];
    this.samplePoints = [];
    this.lowest = {};
    this.highest = {};

    for (var prop in options) {
      if (Object.prototype.hasOwnProperty.call(config, prop)) {
        config[prop] = options[prop];
      }
    }

    if (config.mobileVersion) {
      config.gridWidth = config.gridWidth - 2 * config.offset;
      config.gridStartX = config.gridStartX + config.offset;
      config.wedgeWidth = config.wedgeWidth + config.offset;
      config.points.unshift({ numCorrect: 0, x: 0 });
    }

    if (config.autoWidth) {
      window.onresize = function() {
        self.draw(false);
      };
    }
    origWidth = config.canvasWidth;
    origStartX = config.gridStartX;

    this.renderScorePoint = function(x, y, text, fillColor, textColor) {
      numScorePoints++;
      var group = new Kinetic.Group({
        opacity: config.animate ? 0 : 1,
        y: config.animate ? -20 : 0
      });
      y = y - 15;
      var maxPoint = new Kinetic.Text({
        x: x - 9,
        y: y - 7,
        text: text,
        fontSize: 10,
        width: 18,
        fontFamily: 'Helvetica',
        fill: textColor,
        align: 'center'
      });
      y = y - 2;
      var circle = new Kinetic.Circle({
        x: x,
        y: config.mobileVersion ? y + 7 : y,
        radius: config.mobileVersion ? 8 : 10,
        fill: fillColor,
        stroke: config.markColor
      });
      var triangle = new Kinetic.Shape({
        sceneFunc: function(ctx) {
          ctx.beginPath();
          ctx.moveTo(x - 10, y);
          ctx.quadraticCurveTo(x - 10, y + 7, x, y + 14);
          ctx.quadraticCurveTo(x + 10, y + 7, x + 10, y);
          ctx.fillStrokeShape(this);
        },
        fill: fillColor,
        stroke: config.markColor
      });
      group.add(circle);
      if (!config.mobileVersion) {
        group.add(triangle);
        group.add(maxPoint);
      }
      layer.add(group);
      if (config.animate) {
        var tween = new Kinetic.Tween({
          node: group,
          duration: 0.2,
          y: 0,
          opacity: 1
        });
        setTimeout(function() {
          tween.play();
        }, 1100 + numScorePoints * 250);
      }
    };

    this.renderScorePoints = function() {
      if (!config.points.length) return false;
      var currentX = config.autoWidth
        ? this.samplePoints[this.samplePoints.length - 4]
        : this.samplePoints[this.samplePoints.length - 2];
      var currentY = this.samplePoints[this.samplePoints.length - 1];

      this.renderScorePoint(
        lowestLastYXValue,
        lowestYValue,
        this.highest.numCorrect,
        config.markColor,
        'white'
      );
      this.renderScorePoint(
        currentX,
        currentY,
        config.points[config.points.length - 1].numCorrect,
        config.currentScoreColor,
        'white'
      );
    };

    this.addLineEndings = function(layer) {
      var points = this.samplePoints,
        angle = config.mobileVersion ? 1.6 : 3.3;

      var leftWedge = new Kinetic.Wedge({
        x: points[0] - config.wedgeWidth,
        y: points[1],
        radius: config.wedgeWidth,
        angle: angle,
        fill: config.lineColor,
        rotation: config.mobileVersion ? -0.7 : -1.7
      });

      if (config.showEndWedge) {
        var rightWedge = new Kinetic.Wedge({
          x: config.animate
            ? points[points.length - 2]
            : points[points.length - 2] + config.wedgeWidth,
          y: points[points.length - 1],
          radius: config.animate ? 0 : config.wedgeWidth,
          angle: angle,
          fill: config.lineColor,
          rotation: config.mobileVersion ? 179.3 : 178.3
        });

        layer.add(rightWedge);

        if (config.animate) {
          var tween = new Kinetic.Tween({
            node: rightWedge,
            radius: config.wedgeWidth,
            duration: 0.15,
            x: points[points.length - 2] + config.wedgeWidth
          });
          setTimeout(function() {
            tween.play();
          }, 400);
        }
      }

      layer.add(leftWedge);
    };

    this.renderLine = function() {
      if (!config.points.length) return false;

      var animPoints, self;

      if (config.animate) {
        var firstPoints = [this.samplePoints[0], this.samplePoints[1]];
        animPoints = [];
        self = this;
        for (var i = 0; i < this.samplePoints.length; i++) {
          animPoints.push(i % 2 === 0 ? firstPoints[0] : firstPoints[1]);
        }
      }
      var gridLine = new Kinetic.Line({
        points: config.animate ? animPoints : this.samplePoints,
        stroke: config.lineColor,
        strokeWidth: config.mobileVersion ? 2 : 3,
        lineCap: 'round',
        lineJoin: 'round'
      });

      layer.add(gridLine);
      if (config.animate) {
        var tween = new Kinetic.Tween({
          node: gridLine,
          duration: 0.4,
          points: this.samplePoints
        });
        setTimeout(function() {
          tween.play();
          self.addLineEndings(layer);
        }, 800);
      } else {
        this.addLineEndings(layer);
      }
    };

    this.createMinMaxTextLayer = function() {
      if (!config.points.length) return false;
      var min = _.isUndefined(this.lowest.numCorrect)
          ? '-'
          : this.lowest.numCorrect,
        max = _.isUndefined(this.highest.numCorrect)
          ? '-'
          : this.highest.numCorrect,
        group = new Kinetic.Group({
          opacity: config.animate ? 0 : 1
        }),
        currentX = config.autoWidth
          ? this.samplePoints[this.samplePoints.length - 4]
          : this.samplePoints[this.samplePoints.length - 2],
        currentY = this.samplePoints[this.samplePoints.length - 1],
        textY = 5,
        yThreshold = 41.2,
        minX = config.canvasWidth / 2 - 50,
        maxX = config.canvasWidth / 2 + 12;

      if (!config.mobileVersion) {
        if (currentY < yThreshold && Math.abs(currentX - minX) < 30) {
          minX = currentX - 40;
          if (
            lowestYValue < yThreshold &&
            Math.abs(lowestLastYXValue - minX) < 30
          ) {
            minX = currentX + 15;
          }
        } else if (
          lowestYValue < yThreshold &&
          Math.abs(lowestLastYXValue - minX) < 30
        ) {
          minX = lowestLastYXValue - 40;
        }
        if (currentY < yThreshold && Math.abs(currentX - maxX) < 30) {
          maxX = currentX + 15;
          if (
            lowestYValue < yThreshold &&
            Math.abs(lowestLastYXValue - maxX) < 35
          ) {
            maxX = currentX - 40;
          }
        } else if (
          lowestYValue < yThreshold &&
          Math.abs(lowestLastYXValue - maxX) < 35
        ) {
          maxX = lowestLastYXValue + 15;
        }
      } else {
        var tempPoints = config.points.slice(0);
        tempPoints.shift();
        min = _.min(tempPoints, function(o) {
          return o.numCorrect;
        }).numCorrect;
      }

      var maxText = new Kinetic.Text({
        x: config.mobileVersion ? config.gridStartX - 50 : maxX,
        y: config.mobileVersion ? config.gridStartY - 30 : textY,
        text: 'Max: ' + max,
        fontSize: 9,
        fontFamily: 'Helvetica',
        fill: '#7d7d80',
        align: 'right'
      });

      var minText = new Kinetic.Text({
        x: config.mobileVersion ? config.gridStartX - 50 : minX,
        y: config.mobileVersion ? config.gridStartY - 18 : textY,
        text: 'Min: ' + min,
        fontSize: 9,
        fontFamily: 'Helvetica',
        fill: '#7d7d80',
        align: 'right'
      });
      group.add(maxText);
      group.add(minText);
      layer.add(group);
      if (config.animate) {
        var tween = new Kinetic.Tween({
          node: group,
          opacity: 1,
          duration: 0.2
        });
        setTimeout(function() {
          tween.play();
        }, 2000);
      }
    };

    this.renderDatePoints = function(layer) {
      if (!config.datePoints.length) return false;
      var textWidth = config.mobileVersion ? 50 : 35,
        yPos = config.mobileVersion
          ? config.canvasHeight - 10
          : config.canvasHeight - 20,
        group = new Kinetic.Group({
          opacity: config.animate ? 0 : 1
        }),
        currentXpos = 0,
        offset = config.mobileVersion ? 25 : 10;
      _.each(config.datePoints, function(datePoint) {
        var xPos = Math.floor(
          config.gridStartX + config.gridWidth * datePoint.xPoint
        );
        xPos = xPos > dateMaxOffset ? dateMaxOffset : xPos;
        xPos = xPos - textWidth / 2;

        if (xPos - currentXpos < textWidth / 2 + offset) {
          xPos = currentXpos + textWidth / 2 + offset;
        }
        currentXpos = xPos;

        var dateText = new Kinetic.Text({
          x: xPos,
          y: yPos,
          text: datePoint.dateTime,
          fontSize: 9,
          width: textWidth,
          fontFamily: 'Helvetica',
          fill: config.dateColor,
          align: 'center'
        });
        group.add(dateText);
      });
      layer.add(group);
      if (config.animate) {
        var tween = new Kinetic.Tween({
          node: group,
          opacity: 1,
          duration: 0.2
        });
        setTimeout(function() {
          tween.play();
        }, 2000);
      }
    };

    this.renderTimeGrid = function() {
      var animOffset = config.animate ? 30 : 0,
        startX = origStartX ? origStartX : config.gridStartX;
      gridLineslayer = new Kinetic.Layer();

      for (var i = 0; i < noOfGridLines; i++) {
        var y = config.gridStartY - stepSize * i;
        var grayLine = new Kinetic.Line({
          points: [
            origStartX - config.gridPadding - config.offset,
            y - animOffset,
            origStartX + config.gridWidth + config.gridPadding,
            y - animOffset
          ],
          stroke: 'gray',
          strokeWidth: 0.1,
          opacity: config.animate ? 0 : 1
        });
        gridLineslayer.add(grayLine);
        if (config.animate) {
          animateGrid(
            new Kinetic.Tween({
              node: grayLine,
              duration: 0.2,
              opacity: 1,
              points: [
                startX - config.gridPadding - config.offset,
                y,
                startX + config.gridWidth + config.gridPadding + config.offset,
                y
              ]
            }),
            i
          );
        }
      }
      function animateGrid(tween, counter) {
        setTimeout(function() {
          tween.play();
        }, 100 + counter * 50);
      }
      this.renderDatePoints(gridLineslayer);
      stage.add(gridLineslayer);
    };

    this.normalizePoints = function(points) {
      var linePoints = points;
      if (linePoints === 0) {
        return;
      }

      var normalizedPoints = [];

      this.lowest = _.min(linePoints, function(o) {
        return o.numCorrect;
      });
      this.highest = _.max(linePoints, function(o) {
        return o.numCorrect;
      });

      if (config.autoMinMax) {
        if (this.lowest.numCorrect === this.highest.numCorrect) {
          startLine = 0;
        } else {
          startLine =
            this.lowest.numCorrect > 0
              ? this.lowest.numCorrect - 1
              : this.lowest.numCorrect;
        }

        endLine =
          this.highest.numCorrect < config.numberOfMatches
            ? this.highest.numCorrect + 1
            : this.highest.numCorrect;
      } else {
        startLine =
          config.minMax.min > 0 ? config.minMax.min - 1 : config.minMax.min;
        endLine =
          config.minMax.max < config.numberOfMatches
            ? config.minMax.max + 1
            : config.minMax.max;
      }

      var noOfSteps = endLine - startLine + 1;

      var stepSize = config.gridHeight / noOfSteps;
      lowestYValue =
        config.gridStartY - stepSize * (this.highest.numCorrect - startLine);
      highestYValue =
        config.gridStartY - stepSize * (this.lowest.numCorrect - startLine);

      for (var i = 0; i < linePoints.length; i++) {
        var xPos = linePoints[i].x;
        var numCorrect = linePoints[i].numCorrect;

        var y = config.gridStartY - stepSize * (numCorrect - startLine);
        normalizedPoints.push(
          Math.floor(config.gridStartX + config.gridWidth * xPos),
          y
        );
      }
      return normalizedPoints;
    };
    this.sampleNormPoints = function(points) {
      var linePoints = points;
      var samplePoints = [];
      if (linePoints.length === 0) {
        return;
      }

      var lastYPoint = linePoints[1];

      lastXPoint = linePoints[0];
      var highestYInSample = lastYPoint,
        highestYXInSample = lastXPoint,
        lowestYInSample = lastYPoint,
        lowestYXInSample = lastXPoint;

      samplePoints.push(lastXPoint - 2, lastYPoint);

      samplePoints.push(lastXPoint, lastYPoint);
      var newY = lastYPoint;
      var xPoint = lastXPoint;
      lowestLastYXValue = xPoint;

      for (var i = 1; i < linePoints.length / 2; i++) {
        xPoint = linePoints[i * 2];
        var yPoint = linePoints[i * 2 + 1];

        if (highestYInSample <= yPoint) {
          highestYXInSample = xPoint;
        }
        highestYInSample = Math.max(yPoint, highestYInSample);

        if (lowestYInSample >= yPoint) {
          lowestYXInSample = xPoint;
        }
        lowestYInSample = Math.min(yPoint, lowestYInSample);

        if (
          xPoint >= lastXPoint + config.sampleRate ||
          i === linePoints.length / 2 - 1
        ) {
          newY =
            Math.abs(highestYInSample - lastYPoint) >
            Math.abs(lastYPoint - lowestYInSample)
              ? highestYInSample
              : lowestYInSample;

          if (lowestYInSample === lowestYValue && xPoint !== lowestYXInSample) {
            lowestLastYXValue = lowestYXInSample;
            samplePoints.push(lowestYXInSample, lowestYInSample);
          }

          if (
            highestYInSample === highestYValue &&
            highestYXInSample > lowestYXInSample &&
            xPoint !== highestYXInSample
          ) {
            samplePoints.push(highestYXInSample, highestYInSample);
          }

          if (linePoints.length / 2 - 1 === i) {
            newY = yPoint;
          }

          lastXPoint = xPoint;
          lastYPoint = newY;

          if (newY === lowestYValue) {
            lowestLastYXValue = xPoint;
          }
          samplePoints.push(xPoint, newY);

          highestYInSample = Number.MIN_VALUE;
          lowestYInSample = Number.MAX_VALUE;
        }
      }

      if (config.showEndWedge) {
        samplePoints.push(xPoint + 2, newY);
      }
      return samplePoints;
    };

    this.calculateRatio = function() {
      var noOfMatches = config.numberOfMatches;
      noOfGridLines = noOfMatches > 6 ? noOfMatches : noOfMatches * 2;
      stepSize = config.gridHeight / noOfGridLines;
    };

    this.initializeGrid = function() {
      if (stage) {
        stage.destroy();
      }
      var isHighDpi = window.devicePixelRatio >= 2;
      stage = new Kinetic.Stage({
        container: config.container,
        width: isHighDpi
          ? config.canvasWidth * config.scale
          : config.canvasWidth,
        height: isHighDpi
          ? config.canvasHeight * config.scale
          : config.canvasHeight
      });
      layer = new Kinetic.Layer();
      if (isHighDpi) {
        stage.setScale({ x: config.scale, y: config.scale });
      }
      this.calculateRatio(config.minMax);
    };

    this.newValuesAdded = function() {
      this.normalizedPoints = this.normalizePoints(config.points);
      this.samplePoints = this.sampleNormPoints(this.normalizedPoints);
    };
    this.addPoints = function(points, keepOldPoints) {
      config.points = keepOldPoints ? config.points.concat(points) : points;
      this.normalizedPoints = [];
      this.samplePoints = [];
      this.newValuesAdded();
      this.draw();
    };

    this.clear = function() {
      lowestLastYXValue = config.gridStartX;
      config.points = [];
      numScorePoints = 0;
      layer.destroy();
      gridLineslayer.destroy();
      layer = new Kinetic.Layer();
      stage.add(layer);
    };

    this.draw = function(useAnimation) {
      var animation = config.animate,
        containerWidth = config.container.clientWidth,
        lowest = 900;
      config.animate = useAnimation || false;
      widthDiff = (containerWidth - origWidth) / 2;
      if (config.autoWidth) {
        if (this.samplePoints.length > 1 && !origsamplePoints.length) {
          this.samplePoints.unshift(this.samplePoints[0], this.samplePoints[1]);
          this.samplePoints.push(
            this.samplePoints[this.samplePoints.length - 2],
            this.samplePoints[this.samplePoints.length - 1]
          );
          origsamplePoints = JSON.parse(JSON.stringify(this.samplePoints)); 
        }
        config.canvasWidth = containerWidth + 10;
        config.gridWidth = config.canvasWidth - 112;
        config.gridStartX = origStartX + widthDiff;
        this.samplePoints[2] = config.gridStartX - widthDiff;
        this.samplePoints[this.samplePoints.length - 2] =
          lastXPoint + widthDiff * 2;
        for (var i = 0; i < this.samplePoints.length - 2; i++) {
          if (i % 2 === 0 && i > 1) {
            this.samplePoints[i] = origsamplePoints[i] + widthDiff;
          } else if (i % 2 !== 0 && this.samplePoints[i] < lowest) {
            this.lowest = this.samplePoints[i];
            lowestLastYXValue = this.samplePoints[i - 1];
          }
        }
      }
      if (layer) layer.destroy();
      if (gridLineslayer) gridLineslayer.destroy();
      numScorePoints = 0;
      this.initializeGrid();
      this.renderTimeGrid();
      this.renderLine();
      this.renderScorePoints();
      this.createMinMaxTextLayer();
      stage.add(layer);
      config.animate = animation;
    };

    config.container =
      config.container instanceof jQuery
        ? config.container[0]
        : config.container;
    config.container.className += ' graph-container';

    this.newValuesAdded();

    return {
      addPoints: function(points, keepOldPoints, time) {
        self.addPoints(points, keepOldPoints, time);
      },
      clear: function() {
        self.clear();
      },
      getConfigProp: function(name) {
        return Object.prototype.hasOwnProperty.call(self.config, name)
          ? self.config[name]
          : null;
      },
      setAnimation: function(value) {
        self.config.animate = value;
      },
      draw: function(useAnimation) {
        self.draw(useAnimation);
      },
      getObjectForUnitTests: function() {
        return self;
      }
    };
  };
})(svs, _);

 })(window);